import { render, staticRenderFns } from "./PostData.vue?vue&type=template&id=b942d8ac&scoped=true&"
import script from "./PostData.vue?vue&type=script&lang=js&"
export * from "./PostData.vue?vue&type=script&lang=js&"
import style0 from "./PostData.vue?vue&type=style&index=0&id=b942d8ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b942d8ac",
  null
  
)

export default component.exports